<div class="text-center">
    <p>{{ title }}</p>
    <div mat-dialog-content >
        <mat-spinner [style.margin]="'auto'"></mat-spinner>
    </div>
</div>